import React, { useCallback, useEffect, useRef, useState } from "react";
import Layout from "../../common/Layout";
import {  useSelector } from "react-redux";
import ReactSelect from "react-select";
import { GetDataWithToken, PostDataWithToken } from "../../constants/ApiHelper";
import { FaPlus } from "react-icons/fa";
import _ from "lodash";
import { toast } from "react-toastify";
import ReactPaginate from "react-paginate";

const AddPincode = () => {
    const mmvData = useSelector((state) => state?.root?.mmvData);

    const [loading, setLoading] = useState(false);
    const [addNewRto, setAddNewRto] = useState(false);
    const [partnerRtoData, setPartnerRtoData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);

    const [stateData, setStateData] = useState([]);
    const [cityData, setCityData] = useState([]);
    const [districtData, setDistrictData] = useState([]);
    const [pincodeData, setPincodeData] = useState([]);
    const [localitiesData, setLocalitiesData] = useState([]);

    const [selectedState, setSelectedState] = useState(null);
    const [selectedCity, setSelectedCity] = useState(null);
    const [selectedDistrict, setSelectedDistrict] = useState(null);
    const [selectedPincode, setSelectedPincode] = useState(null);
    const [selectedLocalitie, setSelectedLocalitie] = useState(null);

    const [stateId, setStateId] = useState("");
    const [cityId, setCityId] = useState("");

    const [stateModal, setStateModal] = useState(false);
    const [cityModal, setCityModal] = useState(false);
    const [districtModal, setDistrictModal] = useState(false);
    const [pincodeModal, setPincodeModal] = useState(false);
    const [localityModal, setLocalityModal] = useState(false);

    const [addState, setAddState] = useState("");
    const [addCity, setAddCity] = useState("");
    const [addDistrict, setAddDistrict] = useState("");
    const [addPincode, setAddPincode] = useState("");
    const [addLocality, setAddLocality] = useState("");

    const [variantIdInput, setVariantIdInput] = useState("");
    const [sync, setSync] = useState(false);
    const [pageCount, setPageCount] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);
    const [showSidebar, setShowSidebar] = useState(false);

    // =====================================================
    // API REQUEST CONTROL
    // =====================================================

    const requestLockRef = useRef({});
    const requestIdRef = useRef({});
    const pendingRequestsRef = useRef(0);
    const abortControllerRef = useRef(null);
    const initializedRef = useRef(false);
    const debouncedSearchRef = useRef(null);

    const [formData, setFormData] = useState({
        id: null,
        State: "",
        stateId: "",
        District: "",
        districtId: "",
        City: "",
        cityId: "",
        Pin_Code: "",
        pincodeFullName: "",
        sync: false,
    });

    // const handlePageClick = (e) => {
    //     setCurrentPage(e.selected);
    // };

    const startLoading = useCallback(() => {
        pendingRequestsRef.current += 1;
        setLoading(true);
    }, []);

    const stopLoading = useCallback(() => {
        pendingRequestsRef.current = Math.max(0, pendingRequestsRef.current - 1);

        if (pendingRequestsRef.current === 0) {
            setLoading(false);
        }
    }, []);

    const getStateData = useCallback(async () => {
        const apiKey = "getStates";

        if (requestLockRef.current[apiKey]) {
            console.log("Duplicate state API prevented");
            return;
        }

        requestLockRef.current[apiKey] = true;

        const requestId = (requestIdRef.current[apiKey] || 0) + 1;
        requestIdRef.current[apiKey] = requestId;

        startLoading();

        try {
            const res = await PostDataWithToken("/state/getStates", {
                status: "1",
                stateId: "",
            });

            if (requestId !== requestIdRef.current[apiKey]) {
                return;
            }

            if (res?.status) {
                const arr =
                    res?.data?.map((item) => ({
                        label: item.state,
                        value: item.stateId,
                    })) || [];

                setStateData(arr);
            } else {
                setStateData([]);
            }
        } catch (error) {
            console.error("State API Error:", error);
            setStateData([]);
            toast.error(error?.message || "Failed to load states");
        } finally {
            requestLockRef.current[apiKey] = false;
            stopLoading();
        }
    }, [startLoading, stopLoading]);

    useEffect(() => {
        if (initializedRef.current) {
            return;
        }

        initializedRef.current = true;
        getStateData();
    }, []);

    // ===========================
    // Get Cities
    // ===========================
    const getCityData = useCallback(
        async (selectedStateId) => {
            if (!selectedStateId) {
                return;
            }

            const apiKey = `getCities-${selectedStateId}`;

            if (requestLockRef.current[apiKey]) {
                console.log("Duplicate city API prevented");
                return;
            }

            requestLockRef.current[apiKey] = true;

            const requestId = (requestIdRef.current[apiKey] || 0) + 1;
            requestIdRef.current[apiKey] = requestId;

            startLoading();

            try {
                setCityData([]);
                setDistrictData([]);
                setPincodeData([]);
                setLocalitiesData([]);

                setSelectedCity(null);
                setSelectedDistrict(null);
                setSelectedPincode(null);
                setSelectedLocalitie(null);

                const res = await PostDataWithToken("/cities/getCities", {
                    status: 1,
                    stateId: String(selectedStateId),
                    cityId: "",
                });

                if (requestId !== requestIdRef.current[apiKey]) {
                    return;
                }

                const arr =
                    res?.data?.map((item) => ({
                        label: item.city,
                        value: item.cityId,
                    })) || [];

                setCityData(arr);
            } catch (error) {
                console.error("City API Error:", error);
                setCityData([]);
                toast.error(error?.message || "Failed to load cities");
            } finally {
                requestLockRef.current[apiKey] = false;
                stopLoading();
            }
        },
        [startLoading, stopLoading]
    );

    // ===========================
    // Get District
    // ===========================
    const getDistrictData = useCallback(
        async (selectedStateId, selectedCityId) => {
            if (!selectedStateId || !selectedCityId) {
                return;
            }

            const apiKey = `district-${selectedStateId}-${selectedCityId}`;

            if (requestLockRef.current[apiKey]) {
                console.log("Duplicate district API prevented");
                return;
            }

            requestLockRef.current[apiKey] = true;

            const requestId = (requestIdRef.current[apiKey] || 0) + 1;
            requestIdRef.current[apiKey] = requestId;

            startLoading();

            try {
                setDistrictData([]);
                setPincodeData([]);
                setLocalitiesData([]);

                setSelectedDistrict(null);
                setSelectedPincode(null);
                setSelectedLocalitie(null);

                const res = await PostDataWithToken("pincode/getDistrictData", {
                    stateId: selectedStateId,
                    cityId: selectedCityId,
                });

                if (requestId !== requestIdRef.current[apiKey]) {
                    return;
                }

                if (res?.status) {
                    const arr =
                        res?.data?.map((item) => ({
                            label: item.district_name,
                            value: item.id,
                        })) || [];

                    setDistrictData(arr);
                }
            } catch (error) {
                console.error("District API Error:", error);
                setDistrictData([]);
                toast.error(error?.message || "Failed to load district");
            } finally {
                requestLockRef.current[apiKey] = false;
                stopLoading();
            }
        },
        [startLoading, stopLoading]
    );

    // ===========================
    // Get Pincode
    // ===========================
    const getPincodeData = useCallback(
        async (selectedStateId, selectedCityId, selectedDistrictId) => {
            if (!selectedStateId || !selectedCityId) {
                return;
            }

            const apiKey = `pincode-${selectedStateId}-${selectedCityId}-${
                selectedDistrictId || ""
            }`;

            if (requestLockRef.current[apiKey]) {
                console.log("Duplicate pincode API prevented");
                return;
            }

            requestLockRef.current[apiKey] = true;

            const requestId = (requestIdRef.current[apiKey] || 0) + 1;
            requestIdRef.current[apiKey] = requestId;

            startLoading();

            try {
                setPincodeData([]);
                setLocalitiesData([]);
                setSelectedPincode(null);
                setSelectedLocalitie(null);

                const res = await PostDataWithToken(
                    "pincode/getPincodeByLocation",
                    {
                        stateId: selectedStateId,
                        cityId: selectedCityId,
                        districtId: selectedDistrictId || "",
                    }
                );

                if (requestId !== requestIdRef.current[apiKey]) {
                    return;
                }

                if (res?.status) {
                    const arr =
                        res?.data?.map((item) => ({
                            label: item.pin_code,
                            value: item.id,
                        })) || [];

                    setPincodeData(arr);
                }
            } catch (error) {
                console.error("Pincode API Error:", error);
                setPincodeData([]);
                toast.error(error?.message || "Failed to load pincode");
            } finally {
                requestLockRef.current[apiKey] = false;
                stopLoading();
            }
        },
        [startLoading, stopLoading]
    );

    // ===========================
    // Get Localities
    // ===========================
    const getLocalitiesData = useCallback(
        async (pinCode) => {
            if (!pinCode) {
                return;
            }

            const apiKey = `locality-${pinCode}`;

            if (requestLockRef.current[apiKey]) {
                console.log("Duplicate locality API prevented");
                return;
            }

            requestLockRef.current[apiKey] = true;

            const requestId = (requestIdRef.current[apiKey] || 0) + 1;
            requestIdRef.current[apiKey] = requestId;

            startLoading();

            try {
                setLocalitiesData([]);

                const res = await PostDataWithToken(
                    "pincode/getLocalitiesByPincode",
                    {
                        pinCode,
                    }
                );

                if (requestId !== requestIdRef.current[apiKey]) {
                    return;
                }

                if (res?.status) {
                    const arr =
                        res?.data?.map((item) => ({
                            label: item.locality_name,
                            value: item.id,
                        })) || [];

                    setLocalitiesData(arr);
                }
            } catch (error) {
                console.error("Locality API Error:", error);
                setLocalitiesData([]);
                toast.error(error?.message || "Failed to load localities");
            } finally {
                requestLockRef.current[apiKey] = false;
                stopLoading();
            }
        },
        [startLoading, stopLoading]
    );

    // ===========================
    // Select Handlers
    // ===========================
    const handleSelectState = (option) => {
        setSelectedState(option);
        setStateId(option.value);
        setSelectedCity(null);
        setSelectedDistrict(null);
        setSelectedPincode(null);
        setSelectedLocalitie(null);
        getCityData(option.value);
    };

    const handleSelectCity = (option) => {
        setSelectedCity(option);
        setCityId(option.value);
        setSelectedDistrict(null);
        setSelectedPincode(null);
        setSelectedLocalitie(null);
        getDistrictData(stateId, option.value);
    };

    const handleSelectDistrict = (option) => {
        setSelectedDistrict(option);
        setSelectedPincode(null);
        setSelectedLocalitie(null);
        getPincodeData(stateId, cityId, option.value);
    };

    const handleSelectPincode = (option) => {
        setSelectedPincode(option);
        setSelectedLocalitie(null);
        getLocalitiesData(option.label);
    };

    const handleSelectLocality = (option) => {
        setSelectedLocalitie(option);
    };

    // ===========================
    // Input Handlers
    // ===========================
    const handleAddState = (e) => {
        setAddState(e.target.value);
    };

    const handleAddCity = (e) => {
        setAddCity(e.target.value);
    };

    const handleAddDistrict = (e) => {
        setAddDistrict(e.target.value);
    };

    const handleAddPincode = (e) => {
        setAddPincode(e.target.value);
    };

    const handleAddlocaLity = (e) => {
        setAddLocality(e.target.value);
    };

    // ===========================
    // Submit Add Pincode
    // ===========================
    const handleAddMmv = async () => {
        try {
            startLoading();

            const payload = {
                vehicleType: mmvData?.vehicleType || "",
                State: addState || selectedState?.label || "",
                stateId: stateId || "",
                City: addCity || selectedCity?.label || "",
                cityId: cityId || "",
                District: addDistrict || selectedDistrict?.label || "",
                districtId: selectedDistrict?.value || "",
                Pin_Code: selectedPincode?.label || addPincode,
                Locality: selectedLocalitie?.label || addLocality,
                pincodeFullName: "",
                sync: sync,
            };

            const response = await PostDataWithToken(
                "pincode/addPincode",
                payload
            );

            if (
                response?.status === "success" ||
                response?.status === true
            ) {
                toast.success(
                    response.message || "Pincode added successfully"
                );
                setAddNewRto(false);
                resetAddForm();
                setCurrentPage(0);
                getPartnerRtoRef.current("", "", "", "", 0);
            } else {
                toast.error(response?.message || "Failed to add pincode");
            }
        } catch (error) {
            console.error(error);
            toast.error("Failed to add pincode");
        } finally {
            stopLoading();
        }
    };

    const resetAddForm = () => {
        setSelectedState(null);
        setSelectedCity(null);
        setSelectedDistrict(null);
        setSelectedPincode(null);
        setSelectedLocalitie(null);
        setStateId("");
        setCityId("");
        setAddState("");
        setAddCity("");
        setAddDistrict("");
        setAddPincode("");
        setSync(false);
        setStateModal(false);
        setCityModal(false);
        setDistrictModal(false);
        setPincodeModal(false);
        setLocalityModal(false);
    };

    // ===========================
    // Get Partner Pincodes - Store in Ref to avoid dependency issues
    // ===========================
    const getPartnerRtoRef = useRef(null);

    getPartnerRtoRef.current = async (val1 = "", val2 = "", val3 = "", searchVal = "", pageNum = 0) => {
        console.log("📊 getPartnerRtoRef.current called with params:", { val1, val2, val3, searchVal, pageNum });
        const stateId = val1 || "";
        const cityId = val2 || "";
        const search = searchVal?.trim() || "";
        const pageToFetch = pageNum || 0;

        const apiKey = `getPincode-${stateId}-${cityId}-${search}-${pageToFetch}-${itemsPerPage}`;

        // ✅ PREVENT DOUBLE CALL - Check if same request already in progress
        if (requestLockRef.current[apiKey]) {
            console.log("🚫 Duplicate getPincode API prevented:", apiKey);
            return;
        }

        requestLockRef.current[apiKey] = true;
        const requestId = (requestIdRef.current[apiKey] || 0) + 1;
        requestIdRef.current[apiKey] = requestId;

        // Cancel previous request if exists
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
        }

        abortControllerRef.current = new AbortController();

        startLoading();

        try {
            // Calculate page number for API (1-indexed)
            const apiPage = pageToFetch + 1;

            const partnerObj = {
                limit: itemsPerPage,
                page: apiPage,
                search,
                stateId,
                cityId,
            };

            console.log("📤 Pincode API Payload:", partnerObj);

            const res = await PostDataWithToken(
                "pincode/getPincode",
                partnerObj
            );

            // Check if this is still the active request
            if (requestId !== requestIdRef.current[apiKey]) {
                console.log("⏭️ Old request ignored, new one already in progress");
                return;
            }

            if (res?.status) {
                // Filter active data
                const activeData = (res?.data || []).filter(
                    (item) => item?.isActive !== false
                );

                setPartnerRtoData(activeData);

                // Use totalRecords from API for accurate pagination
                const totalRecordsCount = res?.totalRecords || 0;
                setTotalRecords(totalRecordsCount);

                // Calculate total pages
                const calculatedPageCount = Math.ceil(
                    totalRecordsCount / itemsPerPage
                );
                setPageCount(calculatedPageCount);

                console.log("✅ API Success - Total Records:", totalRecordsCount);
            } else {
                setPartnerRtoData([]);
                setTotalRecords(0);
                setPageCount(0);
            }
        } catch (error) {
            if (error.name === "AbortError") {
                console.log("🛑 Request cancelled");
                return;
            }

            console.error("❌ Pincode API Error:", error);
            toast.error(error?.message || "Failed to fetch pincodes");
            setPartnerRtoData([]);
            setTotalRecords(0);
            setPageCount(0);
        } finally {
            requestLockRef.current[apiKey] = false;
            stopLoading();
        }
    };

    // ===========================
    // DEBOUNCED SEARCH with PROPER IMPLEMENTATION
    // ===========================
    useEffect(() => {
        // Create debounced function
        debouncedSearchRef.current = _.debounce((searchValue) => {
            console.log("🔍 Debounced search triggered with:", searchValue);

            // Reset to first page on search
            setCurrentPage(0);

            // Only call API if search value has at least 3 characters or is empty
            if (searchValue.length === 0 || searchValue.length >= 3) {
                console.log("✅ Calling API with search:", searchValue);
                getPartnerRtoRef.current("", "", "", searchValue, 0);
            } else {
                console.log("⏳ Waiting for 3 characters...");
            }
        }, 800);

        return () => {
            // Cleanup debounce on unmount
            if (debouncedSearchRef.current) {
                debouncedSearchRef.current.cancel();
            }
        };
    }, []);

    // ===========================
    // Search Input Handler
    // ===========================
    const handleVariantIdChange = (e) => {
        const value = e.target.value;
        setVariantIdInput(value);
        debouncedSearchRef.current(value);
    };

    // ===========================
    // Manual Search Button
    // ===========================
    const handleSearch = () => {
        setCurrentPage(0);
        getPartnerRtoRef.current("", "", "", variantIdInput, 0);
    };

    // ===========================
    // Handle Page Change
    // ===========================
    const handlePageChangeWithSearch = (selectedPage) => {
        console.log("📄 Page changed to:", selectedPage.selected);
        setCurrentPage(selectedPage.selected);
        getPartnerRtoRef.current("", "", "", variantIdInput, selectedPage.selected);
    };

    // ===========================
    // Initial Load State Data - ONLY ONCE on Component Mount
    // ===========================
    useEffect(() => {
        if (!initializedRef.current) {
            initializedRef.current = true;
            console.log("🚀 Initial state data load triggered");
            
            // Call getStateData API
            getStateData();
        }
    }, []);

    // ===========================
    // Initial Load Pincode Data - ONLY ONCE on Component Mount
    // ===========================
    useEffect(() => {
        let isMounted = true;

        const loadPincodeData = async () => {
            console.log("📋 Attempting to load pincode data...");
            console.log("📋 getPartnerRtoRef.current exists?", !!getPartnerRtoRef.current);
            console.log("📋 isMounted?", isMounted);
            
            if (isMounted && getPartnerRtoRef.current) {
                console.log("🚀 ✅ Loading Pincode table data");
                try {
                    await getPartnerRtoRef.current("", "", "", "", 0);
                    console.log("🚀 ✅ Pincode data loaded successfully");
                } catch (err) {
                    console.error("🚀 ❌ Error loading pincode data:", err);
                }
            } else {
                console.log("🚀 ❌ Cannot load - ref not ready");
            }
        };

        // Add delay to ensure ref is ready
        const timer = setTimeout(() => {
            loadPincodeData();
        }, 150);

        return () => {
            isMounted = false;
            clearTimeout(timer);
        };
    }, []);

    // ===========================
    // Items Per Page Handler
    // ===========================
    const handleChangeItemPerPage = (value) => {
        console.log("📊 Items per page changed to:", value);
        setItemsPerPage(Number(value));
        setCurrentPage(0);
        getPartnerRtoRef.current("", "", "", variantIdInput, 0);
    };

    // ===========================
    // Edit Handler
    // ===========================
    const handleEditClick = (item) => {
        setFormData({
            id: item?.id || null,
            State: item?.State || "",
            stateId: item?.stateId || "",
            City: item?.City || "",
            cityId: item?.cityId || "",
            District: item?.District || "",
            districtId: item?.districtId || "",
            Pin_Code: item?.Pin_Code || "",
            pincodeFullName: item?.pincodeFullName || "",
            status: item?.status ?? true,
            sync: item?.sync || false,
        });
        setShowSidebar(true);
    };

    // ===========================
    // Form Change Handler
    // ===========================
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: name === "sync" ? value === "true" : value,
        }));
    };

    // ===========================
    // Update Handler
    // ===========================
    const handleUpdateRto = async () => {
        try {
            startLoading();

            const response = await PostDataWithToken(
                `pincode/updatePincode/${formData?.id}`,
                formData,
                ""
            );

            if (response?.status === true) {
                setShowSidebar(false);
                toast.success(
                    response?.message || "Pincode updated successfully"
                );
                getPartnerRtoRef.current("", "", "", variantIdInput, currentPage);
            } else {
                toast.error(
                    response?.message || "Failed to update pincode"
                );
            }
        } catch (error) {
            console.error("Update Error:", error);
            toast.error(
                error?.response?.data?.message || "Failed to update pincode"
            );
        } finally {
            stopLoading();
        }
    };

    // ===========================
    // Status Toggle Handler
    // ===========================
    const handleStatusToggle = async (item) => {
        try {
            startLoading();

            const newStatus = !item.status;

            const response = await GetDataWithToken(
                `pincode/updatePincodeStatus/${item.id}/status=${newStatus}`
            );

            toast.success(response.message);

            // Refresh Data with current pagination
            getPartnerRtoRef.current("", "", "", variantIdInput, currentPage);
        } catch (error) {
            console.error(error);
            toast.error("Failed to update status");
        } finally {
            stopLoading();
        }
    };

    // Calculate showing items count
    const startItem = currentPage * itemsPerPage + 1;
    const endItem = Math.min((currentPage + 1) * itemsPerPage, totalRecords);

    return (
        <Layout>
            <div className="container-fluid py-4 dash_main">
                {/* Search Section */}
                <div className="card">
                    <div className="card-body pt-0 pb-2 d-flex align-items-center justify-content-between">
                        <div className="col-xl-3 col-lg-3 col-md-6 col-12 d-flex align-items-center gap-1">
                            <div>
                                <label>Pincode</label>
                                <div className="mb-3">
                                    <input
                                        type="search"
                                        placeholder="Search by pincode, state, city, district"
                                        className="form-control"
                                        value={variantIdInput}
                                        onChange={handleVariantIdChange}
                                    />
                                </div>
                            </div>
                            <div className="mt-4">
                                <button
                                    className="btn btn-sec"
                                    onClick={handleSearch}
                                >
                                    Search
                                </button>
                            </div>
                        </div>

                        <div>
                            <button
                                className="btn mt-3 btn-sec"
                                onClick={() => {
                                    setAddNewRto(!addNewRto);
                                    if (addNewRto) {
                                        resetAddForm();
                                    }
                                }}
                            >
                                Add Pincode
                            </button>
                        </div>
                    </div>
                </div>

                {/* Add Form Section */}
                {addNewRto && (
                    <div className="card mt-3">
                        <div className="card-body">
                            <div className="row">
                                {/* STATE */}
                                <div className="col-md-4">
                                    <div className="d-flex">
                                        <div className="col-10">
                                            <label>State *</label>
                                            <div className="w-100">
                                                <ReactSelect
                                                    options={stateData}
                                                    value={selectedState}
                                                    placeholder="Select State"
                                                    onChange={handleSelectState}
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="add-sec"
                                            onClick={() =>
                                                setStateModal(
                                                    !stateModal
                                                )
                                            }
                                        >
                                            <FaPlus />
                                        </div>
                                    </div>
                                    {stateModal && (
                                        <input
                                            type="text"
                                            className="form-control mt-2"
                                            placeholder="Enter State"
                                            value={addState}
                                            onChange={
                                                handleAddState
                                            }
                                        />
                                    )}
                                </div>

                                {/* CITY */}
                                <div className="col-md-4">
                                    <div className="d-flex">
                                        <div className="col-10">
                                            <label>City *</label>
                                            <div className="w-100">
                                                <ReactSelect
                                                    options={
                                                        cityData
                                                    }
                                                    value={
                                                        selectedCity
                                                    }
                                                    placeholder="Select City"
                                                    onChange={
                                                        handleSelectCity
                                                    }
                                                    isDisabled={
                                                        !selectedState
                                                    }
                                                />
                                            </div>
                                        </div>
                                        <div
                                            className="add-sec"
                                            onClick={() =>
                                                setCityModal(
                                                    !cityModal
                                                )
                                            }
                                        >
                                            <FaPlus />
                                        </div>
                                    </div>
                                    {cityModal && (
                                        <input
                                            type="text"
                                            className="form-control mt-2"
                                            placeholder="Enter City"
                                            value={addCity}
                                            onChange={
                                                handleAddCity
                                            }
                                        />
                                    )}
                                </div>

                                {/* DISTRICT */}
                                <div className="col-md-4">
                                    <div className="d-flex">
                                        <div className="col-10">
                                            <label>
                                                District *
                                            </label>
                                            <ReactSelect
                                                options={
                                                    districtData
                                                }
                                                value={
                                                    selectedDistrict
                                                }
                                                placeholder="Select District"
                                                onChange={
                                                    handleSelectDistrict
                                                }
                                                isDisabled={
                                                    !selectedCity
                                                }
                                            />
                                        </div>
                                        <div
                                            className="add-sec"
                                            onClick={() =>
                                                setDistrictModal(
                                                    !districtModal
                                                )
                                            }
                                        >
                                            <FaPlus />
                                        </div>
                                    </div>
                                    {districtModal && (
                                        <input
                                            type="text"
                                            className="form-control mt-2"
                                            placeholder="Enter District"
                                            value={addDistrict}
                                            onChange={
                                                handleAddDistrict
                                            }
                                        />
                                    )}
                                </div>

                                {/* PINCODE */}
                                <div className="col-md-4 mt-3">
                                    <div className="d-flex">
                                        <div className="col-10">
                                            <label>
                                                Pin Code *
                                            </label>
                                            <ReactSelect
                                                options={
                                                    pincodeData
                                                }
                                                value={
                                                    selectedPincode
                                                }
                                                placeholder="Select Pin Code"
                                                onChange={
                                                    handleSelectPincode
                                                }
                                                isDisabled={
                                                    !selectedDistrict
                                                }
                                            />
                                        </div>
                                        <div
                                            className="add-sec"
                                            onClick={() =>
                                                setPincodeModal(
                                                    !pincodeModal
                                                )
                                            }
                                        >
                                            <FaPlus />
                                        </div>
                                    </div>
                                    {pincodeModal && (
                                        <input
                                            type="text"
                                            className="form-control mt-2"
                                            placeholder="Enter Pin Code"
                                            value={addPincode}
                                            onChange={
                                                handleAddPincode
                                            }
                                        />
                                    )}
                                </div>

                                {/* LOCALITY */}
                                <div className="col-md-4 mt-3">
                                    <div className="d-flex">
                                        <div className="col-10">
                                            <label>
                                                Locality
                                            </label>
                                            <ReactSelect
                                                options={
                                                    localitiesData
                                                }
                                                value={
                                                    selectedLocalitie
                                                }
                                                placeholder="Select Locality"
                                                onChange={
                                                    handleSelectLocality
                                                }
                                                isDisabled={
                                                    !selectedPincode
                                                }
                                            />
                                        </div>
                                        <div
                                            className="add-sec"
                                            onClick={() =>
                                                setLocalityModal(
                                                    !localityModal
                                                )
                                            }
                                        >
                                            <FaPlus />
                                        </div>
                                    </div>
                                    {localityModal && (
                                        <input
                                            type="text"
                                            className="form-control mt-2"
                                            placeholder="Enter Locality"
                                            value={addLocality}
                                            onChange={
                                                handleAddlocaLity
                                            }
                                        />
                                    )}
                                </div>

                                {/* SYNC */}
                                <div className="col-md-4 mt-3">
                                    <label>Sync</label>
                                    <select
                                        className="form-control"
                                        value={sync.toString()}
                                        onChange={(e) =>
                                            setSync(
                                                e.target.value ===
                                                    "true"
                                            )
                                        }
                                    >
                                        <option value="false">
                                            False
                                        </option>
                                        <option value="true">
                                            True
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div className="d-flex justify-content-end gap-2 mt-4">
                                <button
                                    className="btn btn-secondary"
                                    onClick={() => {
                                        setAddNewRto(false);
                                        resetAddForm();
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-sec"
                                    onClick={handleAddMmv}
                                    disabled={loading}
                                >
                                    {loading
                                        ? "Loading..."
                                        : "Submit"}
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Table Section */}
                <div className="card mt-3">
                    <div className="card-body pt-0 pb-2">
                        <div className="table-responsive p-0">
                            <table className="table align-items-center mb-0">
                                <thead>
                                    <tr>
                                        <th>ID</th>
                                        <th>State</th>
                                        <th>District</th>
                                        <th>City</th>
                                        <th>Pin Code</th>
                                        {/* <th>Full Name</th> */}
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>

                                <tbody>
                                    {partnerRtoData?.length > 0 ? (
                                        partnerRtoData.map((item) => (
                                            <tr key={item.id}>
                                                <td>{item.id}</td>
                                                <td>
                                                    {item.State}
                                                </td>
                                                <td>
                                                    {
                                                        item.District
                                                    }
                                                </td>
                                                <td>{item.City}</td>
                                                <td>
                                                    {item.Pin_Code}
                                                </td>
                                                {/* <td>
                                                    {
                                                        item.pincodeFullName
                                                    }
                                                </td> */}

                                                <td>
                                                    <div className="d-flex align-items-center gap-2">
                                                        <div
                                                            className={`custom-switch ${
                                                                item?.status
                                                                    ? "active"
                                                                    : ""
                                                            }`}
                                                            onClick={() =>
                                                                handleStatusToggle(
                                                                    item
                                                                )
                                                            }
                                                        >
                                                            <div className="switch-circle"></div>
                                                        </div>

                                                        <span
                                                            className={`fw-semibold ${
                                                                item?.status
                                                                    ? "text-success"
                                                                    : "text-danger"
                                                            }`}
                                                        >
                                                            {item?.status
                                                                ? "Active"
                                                                : "Inactive"}
                                                        </span>
                                                    </div>
                                                </td>

                                                <td>
                                                    <button
                                                        type="button"
                                                        className="btn btn-sec btn-sm"
                                                        onClick={() =>
                                                            handleEditClick(
                                                                item
                                                            )
                                                        }
                                                    >
                                                        Update
                                                    </button>
                                                </td>
                                            </tr>
                                        ))
                                    ) : (
                                        <tr>
                                            <td
                                                colSpan="8"
                                                className="text-center"
                                            >
                                                No Data Found
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>

                {/* Pagination */}
                <div className="card mb-4 p-3">
                    <div className="d-flex align-items-center justify-content-between flex-wrap">
                        <div>
                            <p>
                                Showing {startItem} - {endItem} items of{" "}
                                {totalRecords}
                            </p>
                        </div>
                        <div className="main-page-item">
                            <div className="show-page">
                                <select
                                    className="form-control"
                                    value={itemsPerPage}
                                    onChange={(e) =>
                                        handleChangeItemPerPage(
                                            e?.target?.value
                                        )
                                    }
                                >
                                    <option value={10}>
                                        10
                                    </option>
                                    <option value={20}>
                                        20
                                    </option>
                                    <option value={30}>
                                        30
                                    </option>
                                    <option value={50}>
                                        50
                                    </option>
                                    <option value={100}>
                                        100
                                    </option>
                                </select>
                            </div>
                            <div>
                                <ReactPaginate
                                    breakLabel="..."
                                    nextLabel=">"
                                    onPageChange={
                                        handlePageChangeWithSearch
                                    }
                                    pageRangeDisplayed={5}
                                    pageCount={pageCount}
                                    forcePage={currentPage}
                                    previousLabel="<"
                                    renderOnZeroPageCount={
                                        null
                                    }
                                    pageClassName="page-item"
                                    pageLinkClassName="page-link"
                                    previousClassName="page-item"
                                    previousLinkClassName="page-link"
                                    nextClassName="page-item"
                                    nextLinkClassName="page-link"
                                    breakClassName="page-item"
                                    breakLinkClassName="page-link"
                                    containerClassName="pagination"
                                    activeClassName="active"
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Sidebar - Update Form */}
                {showSidebar && (
                    <>
                        <div
                            className="position-fixed top-0 start-0 w-100 h-100"
                            style={{
                                background: "rgba(0,0,0,0.4)",
                                zIndex: 1040,
                            }}
                            onClick={() => setShowSidebar(false)}
                        />

                        <div
                            className="position-fixed top-0 end-0 bg-white shadow"
                            style={{
                                width: "450px",
                                height: "100vh",
                                zIndex: 1050,
                                overflowY: "auto",
                                padding: "20px",
                            }}
                        >
                            <h4 className="mb-4">
                                Update Pincode
                            </h4>

                            {/* State */}
                            <div className="mb-3">
                                <label className="form-label">
                                    State
                                </label>
                                <input
                                    className="form-control"
                                    name="State"
                                    value={
                                        formData.State || ""
                                    }
                                    onChange={handleChange}
                                    placeholder="Enter State"
                                />
                            </div>

                            {/* District */}
                            <div className="mb-3">
                                <label className="form-label">
                                    District
                                </label>
                                <input
                                    className="form-control"
                                    name="District"
                                    value={
                                        formData.District || ""
                                    }
                                    onChange={handleChange}
                                    placeholder="Enter District"
                                />
                            </div>

                            {/* City */}
                            <div className="mb-3">
                                <label className="form-label">
                                    City
                                </label>
                                <input
                                    className="form-control"
                                    name="City"
                                    value={
                                        formData.City || ""
                                    }
                                    onChange={handleChange}
                                    placeholder="Enter City"
                                />
                            </div>

                            {/* Pin Code */}
                            <div className="mb-3">
                                <label className="form-label">
                                    Pin Code
                                </label>
                                <input
                                    className="form-control"
                                    name="Pin_Code"
                                    value={
                                        formData.Pin_Code || ""
                                    }
                                    onChange={handleChange}
                                    placeholder="Enter Pin Code"
                                />
                            </div>

                            {/* Full Name */}
                            <div className="mb-3">
                                <label className="form-label">
                                    Full Name
                                </label>
                                <input
                                    className="form-control"
                                    name="pincodeFullName"
                                    value={
                                        formData.pincodeFullName ||
                                        ""
                                    }
                                    onChange={handleChange}
                                    placeholder="Auto or Manual Full Name"
                                />
                            </div>

                            {/* Sync */}
                            <div className="mb-3">
                                <label>Sync</label>
                                <select
                                    className="form-control"
                                    name="sync"
                                    value={String(
                                        formData.sync
                                    )}
                                    onChange={handleChange}
                                >
                                    <option value="false">
                                        False
                                    </option>
                                    <option value="true">
                                        True
                                    </option>
                                </select>
                            </div>

                            {/* Buttons */}
                            <div className="d-flex gap-2">
                                <button
                                    className="btn btn-success"
                                    onClick={
                                        handleUpdateRto
                                    }
                                    disabled={loading}
                                >
                                    {loading
                                        ? "Updating..."
                                        : "Update"}
                                </button>

                                <button
                                    className="btn btn-secondary"
                                    onClick={() =>
                                        setShowSidebar(false)
                                    }
                                >
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </>
                )}

                {/* Loading Overlay */}
                {loading && (
                    <div
                        className="loader-overlay"
                        style={{
                            position: "fixed",
                            inset: 0,
                            background:
                                "rgba(0,0,0,0.45)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            zIndex: 99999,
                        }}
                    >
                        <div className="text-center bg-white rounded p-4 shadow">
                            <div
                                className="spinner-border text-primary"
                                role="status"
                            />

                            <h5 className="mt-3 mb-1">
                                Loading Pincode Data...
                            </h5>

                            <p className="mb-0 text-muted">
                                Please wait...
                            </p>
                        </div>
                    </div>
                )}
            </div>
        </Layout>
    );
};

export default AddPincode;